import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { PageTitleProvider } from './PageHeader';
import { MemberDrawerProvider } from '@/components/MemberDrawer';
import { useFinanceStream } from '@/hooks/useFinanceStream';
import { useStaffHeartbeat } from '@/hooks/useStaffHeartbeat';
import { Watermark } from './Watermark';

export function AppLayout() {
  useFinanceStream();
  // One beat a minute while this tab is visible and signed in, so a supervisor
  // can staff a shift. Nothing but "this tab is open, on this route" —
  // see the hook.
  useStaffHeartbeat();
  return (
    <PageTitleProvider>
      <MemberDrawerProvider>
        <div className="flex h-screen w-screen overflow-hidden bg-background text-foreground">
          <Sidebar />
          <div className="flex flex-1 flex-col overflow-hidden">
            <TopBar />
            <main className="flex-1 overflow-y-auto p-4 md:p-6">
              <Outlet />
            </main>
          </div>
        </div>
        {/* Last child of the shell and out of flow: every page under the
            Outlet, and every dialog those pages raise, is stamped with who is
            looking at it. */}
        <Watermark />
      </MemberDrawerProvider>
    </PageTitleProvider>
  );
}
